import { useState } from 'react'
import icVideo from '@/assets/ic-video.png'
import { Button, Tooltip } from '@arco-design/web-react'
import { VideoModal } from '@/components/VideoModal'
import useLocale from '@/utils/useLocale'

interface Props {
  url: string
  record: any
}

const VideoButton = ({ url, record }: Props) => {
  const t = useLocale()
  const [visible, setVisible] = useState(false)

  return (
    <>
      <Tooltip content={t['common.list.video_play']}>
        <Button
          style={{ background: 'transparent' }}
          icon={<img src={icVideo?.src} width={32} height={32} />}
          onClick={() => {
            url && setVisible(true)
          }}
        ></Button>
      </Tooltip>
      <VideoModal visible={visible} onCancel={() => setVisible(false)} url={url} videoId={record?.video_id} />
    </>
  )
}

export default VideoButton
